module.exports = {
    server_url: process.env.VUE_APP_API_URL,
    enviornment: process.env.VUE_APP_API_URL
}